import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, Box, Typography } from '@mui/material';
import { createHost, updateHost } from '../../services/hostService';
import { useNavigate, useParams } from 'react-router-dom';

const HostForm = ({ editMode }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const initialValues = {
    name: '',
    description: '',
    mongoUri: ''
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    mongoUri: Yup.string().required('Mongo URI is required')
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (editMode) {
        await updateHost(id, values);
      } else {
        await createHost(values);
      }
      navigate('/hosts');
    } catch (error) {
      console.error('Error saving host:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {editMode ? 'Edit Host' : 'Add Host'}
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Field
              as={TextField}
              name="name"
              label="Name"
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <ErrorMessage name="name" component="div" />

            <Field
              as={TextField}
              name="description"
              label="Description"
              fullWidth
              margin="normal"
              variant="outlined"
              multiline
              rows={4}
            />
            <ErrorMessage name="description" component="div" />

            <Field
              as={TextField}
              name="mongoUri"
              label="MongoDB URI"
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <ErrorMessage name="mongoUri" component="div" />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              sx={{ mt: 2 }}
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default HostForm;